import { Component, HostListener, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormControl,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DistrictListService } from '../../services/raintree/Transmission/district-list.service';
import { SatesListService } from '../../services/raintree/Transmission/sates-list.service';
import { PincodeDetailsData } from '../../services/raintree/interfaces/pincode';
import { PincodeDetailsService } from '../../services/raintree/Transmission/pincode-details.service';
import { log } from 'console';
import { AuthTransmissionService } from '../../services/raintree/Transmission/auth-transmission.service';
import { Auth } from '../../services/raintree/interfaces/auth';
import { RequestMapper } from '../../request-mapper';
import {
  SendEmailOTPResponse,
  SendMobileOTPResponse,
  SignUpResponse,
} from '../../services/raintree/interfaces/raintree-response';
import { SnackbarService } from '../../services/common/snackbar.service';
import { catchError, switchMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-create-account',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss', '../../../styles/_dropdown.scss'],
})
export class CreateAccountComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  districtList: any = [];
  pincodeList: any = []
  stateList: any = [];
  inValid: boolean = false;
  state_name_array: any = [];
  passwordInvalid: boolean = false
  ngOnInit(): void {
    this.signInForm.controls['roleName'].setValue('Field Worker');
    this.signInForm.get('password')?.valueChanges.subscribe((item: any) => {
      if (item && item?.length > 0)
        this.checkPasswordValidation(item)
      else {
        this.passwordInvalid = true
        Object.keys(this.pwdvalidation).forEach(key => {
          this.pwdvalidation[key as keyof typeof this.pwdvalidation] = false;
        });
      }
    })
    this.signInForm.get('firstName')?.valueChanges.subscribe((item: any) => {
      if (item.length > 0 && this.signInForm.get('password')?.value) {
        this.pwdvalidation.nameCheck = !this.signInForm.get('password')?.value!.toLowerCase().includes(item.toLowerCase())
      }
    })
    this.signInForm.get('lastName')?.valueChanges.subscribe((item: any) => {
      if (item.length > 0 && this.signInForm.get('password')?.value) {
        this.pwdvalidation.nameCheck = !this.signInForm.get('password')?.value!.toLowerCase().includes(item.toLowerCase())
      }
    })
    this.signInForm.get('email')?.valueChanges.subscribe((item: any) => {
      if (item.length > 0 && this.signInForm.get('password')?.value) {
        let emailVal: any = this.signInForm.get('lastName')?.value ? this.signInForm.get('lastName')?.value?.toLowerCase() : ' '
        emailVal = emailVal.split('@')[0]
        this.pwdvalidation.emailCheck = !this.signInForm.get('password')?.value!.includes(emailVal.toLowerCase())
      }
    })
  }
  constructor(
    public districtTransmissionService: DistrictListService,
    public stateTransmissionService: SatesListService,
    private router: Router,
    private _pincodeDetails: PincodeDetailsService,
    private _authTransmissionService: AuthTransmissionService,
    private _router: Router,
    private snackbar: SnackbarService,

    private toaster: ToastrService
  ) { }
  pincodeData: any;
  specialChars = `@#$%^&*()_+-=[]{}:.,?~|<>`;
  pwdvalidation: any = {
    lengthCheck: false,
    characterCheck: false,
    consecutiveValueCheck: false,
    emailCheck: false,
    nameCheck: false
  }
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;
  stateName: string = '';
  districtName: any = [];
  signUpResponseSessionId: any;
  mobileOTPSentResponseSessionId: any;
  emailOTPSentResponseSessionId: any;
  loginFormPayload: any;
  emailPayload: any;
  mobilePayload: any;
  emailValue: any;
  mobileValue: any;
  // passwordRegEx = new RegExp(
  //   '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{8,}'
  // );

  signInForm = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    lastName: new FormControl('', [Validators.required]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
    contactNumber: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    reEnterPassword: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
    roleName: new FormControl('', [Validators.required]),
    pinCode: new FormControl('', [Validators.required]),
    stateName: new FormControl('', [Validators.required]),
    districtName: new FormControl('', [Validators.required]),
  });

  // unloadNotification($event: any) {
  //   // Show alert message to the user
  //   const confirmationMessage =
  //     'Are you sure you want to leave? Any unsaved changes will be lost.';

  //   // Standard behavior for most browsers
  //   $event.returnValue = confirmationMessage;

  //   // For some older browsers
  //   return confirmationMessage;
  // }
  // hasUnsavedChanges: boolean = true; // Change this based on your app's logic

  matchPassword(password: any, confirmPassword: any) {
    return password === confirmPassword ? true : false;
  }
  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  toggleConfirmPasswordVisibility(): void {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }

  // getDistrictListFromPincode(state: string) {
  //   this.districtTransmissionService.getDistrictList(state).subscribe({
  //     next: (response: any) => {
  //       if (!response.error) {
  //         let resp = response.data;
  //         resp.forEach((elm: any) => {
  //           this.districtList.push(elm);
  //         });
  //       }
  //     },
  //     error: (error) => {
  //       console.log(error);
  //     },
  //   });
  // }

  markAllAsTouched() {
    Object.values(this.signInForm.controls).forEach((control) => {
      control.markAsTouched();
    });
  }
  goToVerification() {
    console.log('clicked');
    if (this.signInForm.valid && !this.passwordInvalid) {
      this.loginFormPayload = {
        firstName: this.signInForm.get('firstName')?.value,
        lastName: this.signInForm.get('lastName')?.value,
        email: this.signInForm.get('email')?.value,
        contactNumber: this.signInForm.get('contactNumber')?.value,
        address: this.signInForm.get('address')?.value,
        pinCode: this.signInForm.get('pinCode')?.value,
        stateName: this.signInForm.get('stateName')?.value,
        districtName: this.signInForm.get('districtName')?.value,
        role: this.signInForm.get('roleName')?.value,
        password: this.signInForm.get('password')?.value,
        confirmPassword: this.signInForm.get('reEnterPassword')?.value,
      };
      //Successfully Sign Up Complete
      //Send Email Otp
      this.emailPayload = {
        email: this.signInForm.get('email')?.value,
      };

      //Send Phone Otp
      this.mobilePayload = {
        mobileNo: this.signInForm.get('contactNumber')?.value,
      };

      this._authTransmissionService
        .getAuthSignUp(this.loginFormPayload)
        .pipe(
          switchMap((signUpResponse: SignUpResponse) => {
            this.signUpResponseSessionId = signUpResponse.data.sessionId;
            console.log('  this.signUpResponseSessionId', signUpResponse);
            console.log(
              'this.signUpResponseSessionId',
              this.signUpResponseSessionId
            );

            this.emailPayload = {
              email: this.signInForm.get('email')?.value,
              sessionId: this.signUpResponseSessionId,
            };
            this.mobilePayload = {
              mobileNo: this.signInForm.get('contactNumber')?.value,
              sessionId: this.signUpResponseSessionId,
            };

            return forkJoin({
              mobileOtp: this._authTransmissionService.getSentMobileOTP(
                this.mobilePayload
              ),
              emailOtp: this._authTransmissionService.getSentEmailOTP(
                this.emailPayload
              ),
            });
          })
        )
        .subscribe({
          next: ({ mobileOtp, emailOtp }) => {
            console.log('Email OTP Response:', emailOtp);
            this.emailOTPSentResponseSessionId = emailOtp.data.sessionId;
            console.log(
              ' this.emailOTPSentResponseSessionId',
              this.emailOTPSentResponseSessionId
            );
            console.log('Mobile OTP Response:', mobileOtp);
            this.mobileOTPSentResponseSessionId = mobileOtp.data.sessionId;
            console.log(
              ' this.mobileOTPSentResponseSessionId',
              this.mobileOTPSentResponseSessionId
            );
            this.emailValue = this.signInForm.get('email')?.value;
            this.mobileValue = this.signInForm.get('contactNumber')?.value;

            localStorage.setItem(
              'sessionIdUser',
              (this.signUpResponseSessionId)
            );
            localStorage.setItem(
              'sessionIdEmail',
              (this.emailOTPSentResponseSessionId)
            );
            localStorage.setItem(
              'sessionIdMobile',
              (this.mobileOTPSentResponseSessionId)
            );
            localStorage.setItem('email', (this.emailValue));
            localStorage.setItem('phone', (this.mobileValue));
            this.router.navigate(['/create-account-verification'])

            // this.router.navigate(['/create-account-verification'], {
            //   queryParams: {

            //     sessionIdUser: btoa(this.signUpResponseSessionId),
            //     sessionIdEmail: btoa(this.emailOTPSentResponseSessionId),
            //     sessionIdMobile: btoa(this.mobileOTPSentResponseSessionId),
            //     email: btoa(this.emailValue),
            //     phone: btoa(this.mobileValue),
            //   },
            // });
            console.log(btoa(this.emailValue), 'email value while sending');
          },
          error: (error) => {
            console.error(error);
            this.snackbar.snackbar(error, 'ok', 'success-snackbar');
          },
        });
    } else if (this.signInForm.invalid) {
      this.markAllAsTouched();
    }
  }
  async checkPasswordValidation(password: string) {
    const firstName: any = this.signInForm.get('firstName')?.value ? this.signInForm.get('firstName')?.value?.toLowerCase() : ' '
    const lastName: any = this.signInForm.get('lastName')?.value ? this.signInForm.get('lastName')?.value?.toLowerCase() : ' '
    let emailVal: any = this.signInForm.get('email')?.value ? this.signInForm.get('email')?.value?.substring(0, 15) : ' '
    emailVal = emailVal.toLowerCase()
    this.pwdvalidation.nameCheck = !password.toLowerCase().includes(firstName) && !password.toLowerCase().includes(lastName) &&
      !password.toLowerCase().includes('satsang')
    const strongPwdRegex = /^(?!.*(?:'|"|;|\\|\/|`))(?!.*--)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&*()_+\-=\[\]{}:.,?~|<>])[A-Za-z\d@#$%^&*()_+\-=\[\]{}:.,?~|<>]{8,15}$/;
    const valid = strongPwdRegex.test(password);
    const containsEmailPart = emailVal.includes(password.toLowerCase());
    this.pwdvalidation.emailCheck = !(containsEmailPart && password.length <= 15);
    this.pwdvalidation.characterCheck = valid;
    if (password.length >= 8 && password.length <= 15)
      this.pwdvalidation.lengthCheck = true
    else
      this.pwdvalidation.lengthCheck = false;
    this.pwdvalidation.consecutiveValueCheck = await this.hasConsecutiveSequence(password)
    Object.values(this.pwdvalidation).some(value => value === false) ? this.passwordInvalid = true : this.passwordInvalid = false
  }
  async hasConsecutiveSequence(str: string): Promise<boolean> {
    const s = str.toLowerCase(); // make case-insensitive
    const n = s.length;

    for (let i = 0; i < n - 2; i++) {
      // Check if it's a numeric sequence
      if (
        this.isDigit(s[i]) &&
        this.isDigit(s[i + 1]) &&
        this.isDigit(s[i + 2]) &&
        s.charCodeAt(i + 1) === s.charCodeAt(i) + 1 &&
        s.charCodeAt(i + 2) === s.charCodeAt(i) + 2
      ) {
        return false;
      }
      if (
        this.isDigit(s[i]) &&
        this.isDigit(s[i + 1]) &&
        this.isDigit(s[i + 2]) &&
        s.charCodeAt(i + 1) === s.charCodeAt(i) &&
        s.charCodeAt(i + 2) === s.charCodeAt(i)
      ) {
        return false;
      }

      // Check if it's an alphabet sequence
      if (
        this.isLetter(s[i]) &&
        this.isLetter(s[i + 1]) &&
        this.isLetter(s[i + 2]) &&
        s.charCodeAt(i + 1) === s.charCodeAt(i) + 1 &&
        s.charCodeAt(i + 2) === s.charCodeAt(i) + 2
      ) {
        return false;
      }
      if (
        this.isLetter(s[i]) &&
        this.isLetter(s[i + 1]) &&
        this.isLetter(s[i + 2]) &&
        s.charCodeAt(i + 1) === s.charCodeAt(i) &&
        s.charCodeAt(i + 2) === s.charCodeAt(i)
      ) {
        return false;
      }

    }

    for (let i = n; i > n - 2; i--) {
      if (
        this.isDigit(s[i]) &&
        this.isDigit(s[i - 1]) &&
        this.isDigit(s[i - 2]) &&
        s.charCodeAt(i - 1) === s.charCodeAt(i) + 1 &&
        s.charCodeAt(i - 2) === s.charCodeAt(i) + 2
      ) {
        return false;
      }
      if (
        this.isLetter(s[i]) &&
        this.isLetter(s[i - 1]) &&
        this.isLetter(s[i - 2]) &&
        s.charCodeAt(i - 1) === s.charCodeAt(i) + 1 &&
        s.charCodeAt(i - 2) === s.charCodeAt(i) + 2
      ) {
        return false;
      }
    }
    return true;
  }

  private isDigit(ch: string): boolean {
    return ch >= "0" && ch <= "9";
  }

  private isLetter(ch: string): boolean {
    return ch >= "a" && ch <= "z";
  }

  onEnteringPincode() {
    const pincode = this.signInForm.get('pinCode')?.value;
    if (pincode && pincode.length === 6) {
      this.pincodeData = this.signInForm.get('pinCode')?.value;
      this._pincodeDetails.fetchPincodeDetails(this.pincodeData).subscribe({
        next: (response: any) => {
          this.pincodeList = response.data
          this.stateList = Object.keys(this.pincodeList);


          if (this.stateList.length == 1) {
            this.stateName = String(this.stateList);
            // this.stateName
            //   ? this.signInForm.controls['stateName'].setValue(this.stateName)
            //   : '';
            // this.stateName
            //   ? this.signInForm.controls['stateName'].disable()
            //   : this.signInForm.controls['stateName'].enable();
            this.signInForm.patchValue({
              stateName: this.stateList[0],
            });
            this.districtName = Object.keys(this.pincodeList[this.stateList[0]]);
            console.log(this.districtName);
            
            // if (this.districtName.length > 1) {
            //   this.signInForm.controls['districtName'].enable();
            // } 
            if (this.districtName.length == 1) {
              this.signInForm.patchValue({
                districtName: this.districtName[0]
              })
              // this.signInForm.controls['districtName'].disable();
            }
          }else{
            console.log(this.stateList);
            
          }

          console.log(this.signInForm.value);
        },
        error: (error) => { },
      });
    }
  }
  getDistrict(event: any) {
    this.districtName = Object.keys(this.pincodeList[event.value])
    this.signInForm.patchValue({
      districtName: this.districtName[0]
    })
  }
  // restrictContactInput(event: KeyboardEvent): void {
  //   const input = event.key;
  //   const limit = event.target as HTMLInputElement;
  //   const pattern = /[0-9]/;

  //   if (
  //     this.allowedKeys.includes(input) ||
  //     event.ctrlKey ||
  //     event.altKey ||
  //     event.metaKey
  //   ) {
  //     return;
  //   }
  //   if (!pattern.test(input) || limit.value.length > 9) {
  //     event.preventDefault(); // Prevent input if it doesn't match the pattern
  //   }
  // }
  restrictContactInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;

    // Allowed keys (e.g., Backspace, Delete, Arrow keys, etc.)
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Escape',
      'Enter',
    ];

    // Allow key combinations with Ctrl, Alt, or Meta keys
    if (
      allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }

    // Check if the input is a digit and the input length is within the limit
    if (!pattern.test(input) || limit.value.length >= 10) {
      event.preventDefault();
      return;
    }

    // Check the first digit to ensure it is between 6 and 9
    if (limit.value.length === 0 && !/[6-9]/.test(input)) {
      event.preventDefault();
    }
  }
  restrictPincodeInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /^[0-9]$/; // Only allow single digit numbers

    // Allow navigation keys, backspace, delete, etc.
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
    ];

    if (
      allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }

    // Prevent input if it doesn't match the pattern or if the length exceeds 6
    if (!pattern.test(input) || limit.value.length >= 6) {
      event.preventDefault();
    }
  }

  // restrictNameInput(event: KeyboardEvent): void {
  //   const input = event.key;

  //   const pattern = /^[a-zA-Z\s]+$/;
  //   if (
  //     this.allowedKeys.includes(input) ||
  //     event.ctrlKey ||
  //     event.altKey ||
  //     event.metaKey
  //   ) {
  //     return;
  //   }
  //   if (!pattern.test(input)) {
  //     event.preventDefault(); // Prevent input if it doesn't match the pattern
  //   }
  // }
  restrictNameInput(event: KeyboardEvent): void {
    const input = event.key;
    const target = event.target as HTMLInputElement;
    const pattern = /^[a-zA-Z\s]+$/;

    // Allowed keys (e.g., Backspace, Delete, Arrow keys, etc.)
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Escape',
      'Enter',
    ];

    // Allow key combinations with Ctrl, Alt, or Meta keys
    if (
      allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }

    // Prevent input if it doesn't match the pattern
    if (!pattern.test(input)) {
      event.preventDefault();
      return;
    }

    // Prevent initial spacing
    if (target.value.length === 0 && input === ' ') {
      event.preventDefault();
    }
  }

  restrictAddressInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;


    const pattern = /^[a-zA-Z0-9,-\s]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 120) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  restrictPasswordInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;

    const pattern = /^[a-zA-Z0-9@-_.]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length >= 20) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  restrictConfirmPasswordInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;

    // const pattern = /^[a-zA-Z0-9@-_.]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (limit.value.length >= 15) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  // restrictConfirmPasswordInput(event: KeyboardEvent): void {
  //   const input = event.key;
  //   const limit = event.target as HTMLInputElement;

  //   const pattern = /^[a-zA-Z0-9@-_.]+$/;
  //   if (
  //     this.allowedKeys.includes(input) ||
  //     event.ctrlKey ||
  //     event.altKey ||
  //     event.metaKey
  //   ) {
  //     return;
  //   }
  //   if (!pattern.test(input) || limit.value.length >= 20) {
  //     event.preventDefault(); // Prevent input if it doesn't match the pattern
  //   }
  // }
  restrictEmailInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;

    const pattern = /^[a-zA-Z0-9@._-]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length >= 50) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
}
